
export default ({icon, title, subtitle, button, buttonClick}) =>
    <>
        <div
            style={{display: "flex", justifyContent: "center", marginTop: 192}}>
            <img style={{display: "block", width: "90%"}} src={icon}/>
        </div>
        <div style={{position: "fixed", bottom: 34, width: "calc(100% - 32px)"}}>
            <div style={{textAlign: "left"}}>
                <div style={{fontSize: 19, fontWeight: 600, letterSpacing: "-0.02em", marginBottom: 2}}>{title}</div>
                <div style={{fontSize: 16, letterSpacing: "-0.015em"}}>{subtitle}</div>
            </div>
            {button && <button style={{
                marginTop: 20,
                padding: "13px 16px 15px 16px",
                width: "100%",
                background: "#1414140F",
                borderRadius: 10,
                border: 0,
                fontSize: 16,
                color: "#1BA136",
                letterSpacing: -0.15,
                fontWeight: 600,
            }} onClick={() => buttonClick && buttonClick()}>{button}
            </button>}
        </div>
    </>
